/* eslint-disable no-shadow */
export enum Ord {
    Less = -1,
    Equal = 0,
    Greater = 1,
}
